export enum AttachmentViewPermissions {
  VIEW_PREVIOUSLY_SENT_MEDIA = 'VIEW_ATTACHMENT_HISTORY',
}
